import React from "react";
import { Badge, Button, Card, Col, DatePicker, Input, Row, Space, Typography } from "antd";
import { ClearOutlined, FilterOutlined } from "@ant-design/icons";

import { useTranslation } from "../../i18n/LanguageProvider";

const { RangePicker } = DatePicker;
const { Text } = Typography;

/**
 * Free-text search and the executed date range.
 *
 * Currency and institution are filtered from their own column headers in the table, so they are
 * deliberately not repeated here.
 */
function RateFilters({
    search,
    setSearch,
    executedDateRange,
    setExecutedDateRange,
    columnFilterCount = 0,
    totalRows = 0,
    onClear,
}) {
    const { t } = useTranslation();

    const activeFilterCount =
        [!!search, !!(executedDateRange && executedDateRange.length === 2)].filter(Boolean).length +
        columnFilterCount;

    return (
        <Card
            bordered={false}
            className="shadow-sm rounded-2xl"
            title={
                <Space>
                    <FilterOutlined />
                    <span>{t("filter.title")}</span>
                    <Badge count={activeFilterCount} />
                </Space>
            }
            extra={<Text type="secondary">{`${t("filter.totalRows")}: ${totalRows}`}</Text>}
        >
            <Row gutter={[12, 12]}>
                <Col xs={24} md={14}>
                    <Input.Search
                        placeholder={t("rate.filter.search")}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        allowClear
                    />
                </Col>

                <Col xs={24} sm={16} md={7}>
                    <RangePicker
                        style={{ width: "100%" }}
                        value={executedDateRange}
                        onChange={setExecutedDateRange}
                        placeholder={[t("filter.dateFrom"), t("filter.dateTo")]}
                    />
                </Col>

                <Col xs={24} sm={8} md={3}>
                    <Button block icon={<ClearOutlined />} onClick={onClear}>
                        {t("action.clear")}
                    </Button>
                </Col>
            </Row>
        </Card>
    );
}

export default RateFilters;
